<template>
  <a-layout class="s_bf">
    <a-card :bordered="false">
      <a-form ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
        <a-form-item ref="activity_name" label="活动名称" name="activity_name" required help="最大不超过18个字">
          <a-input v-model:value="form.activity_name" placeholder='请输入活动名称' style="width:400px" :maxlength="18"></a-input>
        </a-form-item>
        <a-form-item label="活动时间" name='end_time' required help='活动时间需与活动宣传的活动规则保持一致'>
          <a-range-picker v-model:value="time" :show-time="{ format: 'YYYY-MM-DD HH:mm' }" style="width:400px" valueFormat='YYYY-MM-DD HH:mm:ss' format='YYYY-MM-DD HH:mm:ss' @change="onChange" />
        </a-form-item>
        <a-form-item label="扫码模板" name='template_uuid' required help="只能选择导购模板类型的模板">
          <a-row :gutter="16">
            <a-col :span="9">
              <a-input readonly placeholder='请选择关联模板' v-model:value="form.template_name" />
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="templateVisible=true">选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="发奖方式" name='send_award_type'>
          <a-radio-group v-model:value="form.send_award_type" :disabled="actionType=='edit'||isAction">
            <a-radio :value="1">按角色发奖</a-radio>
            <a-radio :value="2">按概率发奖</a-radio>
            <a-tooltip placement="right">
              <template #title>
                1、按角色发奖：100%<br/>
                2、按概率发奖：不支持指定中奖角色，中奖概率可以小于100%<br/>
                3、请注意，为了保证活动奖项数据的有效性，点击“下一步”后，发奖方式不可修改
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="活动规则" name='is_rule'>
          <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_rule" />
        </a-form-item>
        <a-form-item label="规则标题" name='rule_title' v-if="form.is_rule" help="最长不超过12个字符">
          <a-input v-model:value="form.rule_title" placeholder='请输入规则标题' style="width:400px" :maxlength="12"></a-input>
        </a-form-item>
        <a-form-item label="规则内容" name='rule_content' required v-show="form.is_rule">
          <quill v-model:value="form.rule_content" :content="form.rule_content" />
        </a-form-item>
        <a-form-item label="活动备注" name='remarks'>
          <a-textarea v-model:value="form.remarks" placeholder='请输入活动备注' showCount :rows="4" :maxlength="50" style="width:400px" />
        </a-form-item>
        <a-button type="primary" @click="next()" class="marigin_lr_auto">下一步</a-button>
      </a-form>
    </a-card>
    <a-modal :keyboard="false" v-model:visible="templateVisible" centered :width='1200' @ok="handleChoose" destroyOnClose v-if="templateVisible">
      <selectTemplate v-on:success="templateHandle" v-if="templateVisible" :template_type="6" />
    </a-modal>
    <a-modal  :keyboard="false" title="选择红包" v-model:visible="showRed" :maskClosable="false" centered :width='1400' :footer="null" destroyOnClose>
    <selectBouns v-on:select="redSelect"  :scene_type="1" :checkout='false'></selectBouns>
  </a-modal>
  </a-layout>
</template>

<script>
  
  import {
    QuestionCircleOutlined,
  } from "@ant-design/icons-vue";
import {
  activitysOneCreate,
  activitysOneDetail,
  activitysOneUpdate,
} from "@/api/guide";
import { inject, provide, ref } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
const def = {
  activity_name: "",
  activity_type: 1, //先写死 活动类型
  start_time: "",
  end_time: "",
  template_uuid: "",
  award_type: 2,
  is_rule: 0,
  rule_title: "",
  rule_content: "",
  remarks: "",
  template_name: "",
  award_is_bonus: 0,
  award_bonus_info: {
    bonus_id: "",
  },
  award_is_point: 0,
  award_point_info: {
    point_num: null,
  },
  send_award_type:1
};

export default {
  
  components: {
      QuestionCircleOutlined,
    },
  props: {
    activity_id: {
      type: Number,
      default: () => {
        return null;
      },
    },
    actionType:{ //操作类型
      type:String
    },
    isAction:{ // 是否已经下一步过
      type:Boolean
    }
  },
  setup(props, { emit }) {
    let rule_content = async() =>{
      if (form.value.is_rule&&!form.value.rule_content) {
        return Promise.reject('请输入规则内容！');
      } else {
        return Promise.resolve();
      }
    }
    const rules = ref({
      activity_name: [
        {
          required: true,
          message: "请输入活动名称",
        },
      ],
      template_uuid: [
        {
          required: true,
          message: "请选择模板",
        },
      ],
      end_time: [
        {
          required: true,
          message: "请选择活动时间",
        },
      ],
      send_award_type: [
        {
          required: true,
          message: "请选择发奖方式",
        },
      ],
      rule_content: [
        { required: true, validator: rule_content}
      ],
      rule_title: [
        {
          required: true,
          message: "请输入规则标题",
        },
      ],
    });
    const labelCol = { span: 3 };
    const wrapperCol = { span: 16 };
    const form = ref({...def});
    const time = ref(null);
    const ruleForm = ref();
    // 修改时间
    const onChange = (e) => {
      form.value.start_time = e[0];
      form.value.end_time = e[1];
    };
    // 获取详情
    const detail = async () => {
      let result = await activitysOneDetail(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        form.value = result.data;
        time.value = [result.data.start_time, result.data.end_time];
        emit("template_type", form.value.template_type);
      } else {
        message.error(result.message);
      }
    };
    // 下一步
    const next = () => {
      if (props.activity_id) {
        update();
      } else {
        create();
      }
    };
    // 创建
    const create = () => {
      ruleForm.value.validate().then(async (res) => {
        let result = await activitysOneCreate({
          ...form.value,
          award_is_bonus:form.value.award_is_bonus?1:0,
          award_is_point:form.value.award_is_point?1:0
        })
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          emit("setpsOneDone", {
            ...form.value,
            award_is_bonus:form.value.award_is_bonus?1:0,
            award_is_point:form.value.award_is_point?1:0,
            activity_id: result.data.activity_id,
          });
        }
      }).catch(error => {
        message.error('请完善表单！');
      });
    };
    // 修改
    const update = () => {
      ruleForm.value.validate().then(async (res) => {
        let result = await activitysOneUpdate(props.activity_id, form.value)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          emit("setpsOneDone", {
            ...form.value,
            activity_id: result.data.activity_id,
          });
        }
      }).catch(error => {
        message.error('请完善表单！');
      });
    };
    // 选择模板
    const templateVisible = ref(false);
    const templateHandle = (data) => {
      form.value.template_uuid = data.template_uuid;
      form.value.template_name = data.name;
      form.value.template_type = data.type;
      console.log(data.type);
      emit("template_type", data.type);
      templateVisible.value = false;
    };
    const changAwardContent = (e) => {
      console.log(e);
    };
    const showRed=ref(false)
    const redSelect=(data)=>{
      if(!data.id)return
       form.value.award_bonus_info={
        bonus_id:data.id,
        award_content:data.amount+`(${data.bonus_type_text})`
      }
      showRed.value=false
    }
    return {
      form,
      rules,
      ruleForm,
      time,
      labelCol,
      wrapperCol,
      onChange,
      create,
      update,
      detail,
      next,
      templateHandle,
      templateVisible,
      changAwardContent,
      showRed,
      redSelect
    };
  },
};
</script>